// Distributor type options by CountryCode

export var DistributorTypeConfigurations = (function() {
    var getDistributorConfigs= function(countryCode, USER_TYPE, strings) {
        switch (countryCode) {
        case 'FR':
            var multiDisplay = true;
            var getDistributorTypes = [];
            var agent = {
                type: USER_TYPE.AGENT,
                label: strings.get('tdc_agentButton'),
                description: strings.get('tdc_agentDescription'),
                queryParameter: USER_TYPE.AGENT
            };
            var retailer = {
                type: USER_TYPE.RETAILER,
                label: strings.get('tdc_retailerButton'),
                description: strings.get('tdc_retailerDescription'),
                queryParameter: USER_TYPE.RETAILER
            };
            getDistributorTypes.push(agent, retailer);
            return {
                multiDisplay: multiDisplay,
                getDistributorTypes: getDistributorTypes
            };
        default:
            var multiDisplay = false;
            var getDistributorTypes = [];
            var distributor = {
                type: USER_TYPE.PRIMARY_DISTRIBUTOR,
                label: strings.get('tdc_brandAffiliateButton'),
                description: strings.get('tdc_brandAffiliateDescription'),
                queryParameter: USER_TYPE.PRIMARY_DISTRIBUTOR
            };
            getDistributorTypes.push(distributor);
            return {
                multiDisplay: multiDisplay,
                getDistributorTypes: getDistributorTypes
            };
        }
    };
    return {
        getDistributorConfigs: getDistributorConfigs
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/customer-types/distributor-type-configurations.js
// module id = 347
// module chunks = 0